<template>
  <Card class="study-summ-card" v-if="model">
    <p slot="title" class="clearfix">
      <span><Icon :type="icon" :style="'color:' + color"/> {{ model.abbreviation }}</span>
    </p>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">研究名称</Col>
        <Col :span="18">{{ model.study_name }}</Col>
      </Row>
    </div>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">研究代码</Col>
        <Col :span="18">{{ model.code }}</Col>
      </Row>
    </div>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">研究对象</Col>
        <Col :span="18">{{ model.typeText }}</Col>
      </Row>
    </div>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">类型或分期</Col>
        <Col :span="18">{{ model.phaseText }}</Col>
      </Row>
    </div>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">申办方</Col>
        <Col :span="18">{{ model.sponsor }}</Col>
      </Row>
    </div>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">随机化方案</Col>
        <Col :span="18">{{ model.randomText }}</Col>
      </Row>
    </div>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">盲法</Col>
        <Col :span="18">{{ model.maskingText }}</Col>
      </Row>
    </div>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">计划样本量</Col>
        <Col :span="18">{{ model.sample }} 例</Col>
      </Row>
    </div>
    <div class="text item">
      <Row :gutter="20">
        <Col :span="6">研究摘要</Col>
        <Col :span="18">{{ model.description }}</Col>
      </Row>
    </div>
  </Card>
</template>

<script>
export default {
  name: 'study-info',
  data: function () {
    return {
      sts: {
        '1': {
          color: '#acaeb3',
          icon: 'ios-flag'
        },
        '2': {
          color: '#2d8cf0',
          icon: 'ios-loading'
        },
        '3': {
          color: '#ff9900',
          icon: 'ios-pause'
        },
        '4': {
          color: '#19be6b',
          icon: 'ios-checkmark-circle'
        },
        '5': {
          color: '#8B5A00',
          icon: 'ios-archive'
        }
      }
    }
  },
  computed: {
    icon: function () {
      return this.sts[this.model.status].icon
    },
    color: function () {
      return this.sts[this.model.status].color
    }
  },
  props: ['model']
}
</script>

<style>
.study-summ-card {
  height: 640px;
}
.text.item {
  padding: 5px 0;
}
</style>
